import React from "react";

const CookiePolicy = () => (
  <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
    <h1>Cookie Policy MatikaMistr</h1>
    <p><strong>Účinnost od:</strong> 8.12.2025 </p>
    <hr />
    <h2>1. Co jsou cookies a místní úložiště</h2>
    <p>Aby naše platforma správně fungovala, ukládáme do vašeho zařízení malé datové soubory.</p>
    <ul>
      <li><strong>Cookies:</strong> Malé textové soubory, které prohlížeč odesílá zpět na server.</li>
      <li><strong>Local Storage (Místní úložiště):</strong> Prostor ve vašem prohlížeči, kam si web může uložit data (např. o tom, že jste přihlášeni), která se neposílají na server s každým kliknutím, ale zůstávají u vás.</li>
    </ul>
    <p>V tomto dokumentu pro zjednodušení používáme termín „cookies“ pro obě tyto technologie.</p>
    <hr />
    <h2>2. Jaké údaje ukládáme a proč</h2>
    <h3>2.1 Nezbytné (technické) údaje</h3>
    <p>Tyto údaje jsou nutné pro to, aby se vám web vůbec zobrazil, abyste se mohli přihlásit a plnit úlohy. Bez nich by MatikaMistr nefungoval.</p>
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "1rem" }}>
      <thead>
        <tr>
          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Název / Klíč</th>
          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Kde se ukládá</th>
          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Doba uložení</th>
          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Účel</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>auth_token</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Local Storage</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Do odhlášení (max 30 dní)</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Udržuje vás přihlášené, abyste nemuseli zadávat heslo při každém kliknutí.</td>
        </tr>
        <tr>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>theme_preference</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Local Storage</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Trvalé</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Pamatuje si vaše nastavení (např. tmavý/světlý režim), pokud je k dispozici.</td>
        </tr>
        <tr>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>cookie_consent</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Local Storage</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>1 rok</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Pamatuje si, zda jste souhlasili s analytikou, abychom se vás neptali pokaždé znovu.</td>
        </tr>
      </tbody>
    </table>
    <p><strong>Právní základ:</strong> Tyto údaje jsou technicky nezbytné pro poskytování služby (dle § 89 odst. 3 zákona o elektronických komunikacích) a nepotřebujeme k nim váš aktivní souhlas.</p>
    <hr />
    <h3>2.2 Analytické nástroje (Volitelné)</h3>
    <p>Tyto nástroje nám pomáhají pochopit, jak se na webu pohybujete, které úlohy jsou příliš těžké nebo kde se zaseknete. Pomáhají nám platformu zlepšovat.</p>
    <p><strong>Google Analytics 4</strong> (Google Ireland Limited)</p>
    <ul>
      <li>Měříme anonymní statistiky návštěvnosti.</li>
      <li><strong>Nesmíme a nesbíráme</strong> žádné osobní údaje, které by vás přímo identifikovaly (jako e-mail nebo jméno) v rámci analytiky.</li>
      <li>IP adresy jsou anonymizovány.</li>
    </ul>
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "1rem" }}>
      <thead>
        <tr>
          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Cookie</th>
          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Účel</th>
          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Doba platnosti</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>_ga</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Rozlišení unikátních uživatelů (anonymně)</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>2 roky</td>
        </tr>
        <tr>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>_ga_*</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>Udržení stavu návštěvy (session)</td>
          <td style={{ border: "1px solid #ccc", padding: "8px" }}>2 roky</td>
        </tr>
      </tbody>
    </table>
    <p><strong>Vaše volba:</strong> Tyto cookies se načtou <strong>pouze pokud nám k tomu dáte souhlas</strong> v liště při první návštěvě.</p>
    <hr />
    <h2>3. Správa nastavení</h2>
    <p>Své preference můžete kdykoliv změnit.</p>
    <p><strong>Jak odvolat souhlas:</strong><br />Odkaz na „Nastavení cookies“ najdete v patičce webové stránky. Zde můžete analytiku kdykoliv vypnout.</p>
    <p><strong>Nastavení v prohlížeči:</strong></p>
    <ul>
      <li>Google Chrome: Nastavení &gt; Ochrana soukromí</li>
      <li>Mozilla Firefox: Možnosti &gt; Soukromí a zabezpečení</li>
      <li>Safari / Edge: Nastavení &gt; Soukromí</li>
    </ul>
    <p><em>Upozornění: Pokud v prohlížeči úplně zakážete Local Storage nebo technické cookies, nepůjde se do aplikace přihlásit.</em></p>
    <hr />
    <h2>4. Kontakt</h2>
    <p>Pokud máte dotazy k tomu, jak s daty na vašem zařízení pracujeme, napište nám na:</p>
    <p><strong>info@matikamistr.cz</strong></p>
    <p><strong>Datum poslední aktualizace:</strong> 6.12.2025</p>
  </div>
);

export default CookiePolicy;
